import { FranchiseAppGlobal } from '../../app/franchise-app-global'
import { HttpClient } from '@angular/common/http'
import { AppConfigService } from '../shared/providers/config.service';
import { Injectable } from '@angular/core'
import { GetTradeMarkByCRNumberModel, GetTradeMarkInfoByTMIdModel } from '../shared/models/models';
import { Observable } from 'rxjs';

@Injectable()
export class TradeMarkService {
    private env;
    constructor(
        public http: HttpClient,
        private config: AppConfigService
    ) {
        this.env = this.config.getConfig();
    }

    GetTradeMarkByCRNumber(crNumber: any): Observable<GetTradeMarkByCRNumberModel[]> {
        let url = this.env.baseUrl + FranchiseAppGlobal.getTradeMarkByCRNumber + crNumber
        return this.http.get<GetTradeMarkByCRNumberModel[]>(url)
    }
    GetTradeMarkInfoByTMId(tmId: any): Observable<GetTradeMarkInfoByTMIdModel> {
        let url = this.env.baseUrl + FranchiseAppGlobal.getTradeMarkInfoByTMId + tmId
        return this.http.get<GetTradeMarkInfoByTMIdModel>(url)
    }
}
